<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/msc_seminar_2024_heddar.jpg" class="only_pc" />
        <img src="@/assets/img/lp/msc_seminar_2024_heddar.jpg" class="only_sp" />
      </div>
    </div>
  </section>

  <section class="msc_seminar mt-5">
    <p class="mt-5 mb-5 p-3 d-flex justify-content-around">
      <span class="d-flex justify-content-center align-items-center" style="font-size: 2.5rem;">全会場とも</span>
      <span class="d-flex justify-content-center">
        【受付開始】12:30〜<br>
        【開催時間】13:00〜15:30（予定）<br>
        ※各会場によりプログラムが若干異なる場合もございます。<br>
        &emsp;よって終了時間も変更となる場合がございます。
      </span>
    </p>
    <div class="only_pc">
      <table class="seminar_table w-100">
        <thead>
          <tr>
            <th style="width: 100px;">日付</th>
            <th colspan="2">開催地域</th>
            <th>会場</th>
            <th style="width: 150px;"></th>
          </tr>
        </thead>
        <tbody>

          <!-- PC：大宮 -->
          <tr>
            <td class="text-center">6/17<br>（水）</td>
            <td class="text-center"><a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a></td>
            <td style="width: 70px;">大宮</td>
            <td>
              パレスホテル大宮 [4階 ローズルーム]<br>
              定員数：80名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：大宮ここまで -->

          <!-- PC：大阪 -->
          <tr>
            <td class="text-center">6/25<br>（木）</td>
            <td class="text-center"><a href="https://www.granvia-osaka.jp/access/"><img src="@/assets/img/lp/oosaka_2.jpg" alt="大阪" style="width: 150px;"></a></td>
            <td style="width: 70px;">大阪</td>
            <td>
              ホテルグランヴィア大阪 [名庭]<br>
              定員数：100名様<br>
              大阪市北区梅田3丁目1番1号(フロント19階)<br>
              0570-06-1235
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：大阪ここまで -->
          
          <!-- PC:東京 -->
          <tr>
            <td class="text-center">7/24<br>（金）</td>
            <td class="text-center"><a href="https://tokyo.hiltonjapan.co.jp/access/"><img src="@/assets/img/lp/tokyo_hilton.jpg" alt="東京" style="width: 150px;"></a></td>
            <td style="width: 70px;">東京</td>
            <td>
              ヒルトン東京 [3階 藤]<br>
              定員数：120名様<br>
              東京都新宿区西新宿6-6-2<br>
              03-3344-5111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC:東京ここまで -->
          
          <!-- PC：福岡 -->
          <!-- <tr>
            <td class="text-center">6/3<br>（水）</td>
            <td class="text-center"><a href="https://fukuoka-orientalhotel.com/access/"><img src="@/assets/img/lp/hakata.jpg" alt="福岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">福岡</td>
            <td>
              オリエンタルホテル福岡 博多ステーション<br>[オリエンタルボールルーム 山笠]<br>
              定員数：100名様<br>
              福岡県福岡市博多区博多駅中央街4-23<br>
              092-461-0170
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：福岡ここまで -->
          
          <!-- PC：静岡 -->
          <!-- <tr>
            <td class="text-center">5/24<br>（日）</td>
            <td class="text-center"><a href="https://grandhillsshizuoka.jp/access/"><img src="@/assets/img/lp/shizuoka.jpg" alt="静岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">静岡</td>
            <td>
              グランヒルズ静岡<br>[5F センチュリールーム]<br>
              定員数：100名様<br>
              静岡県静岡市駿河区南町18-1<br>
              050-3185-7809
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：静岡ここまで -->

          <!-- PC：大村 -->
          <!-- <tr>
            <td class="text-center">5/18（月）</td>
            <td class="text-center"><a href="https://parkbells.net/access/"><img src="@/assets/img/lp/nagasaki_oomura.jpg" alt="大村" style="width: 150px;"></a></td>
            <td style="width: 70px;">大村</td>
            <td>
              MSCセミナー大村<br>
              パークベルズ大村 [デュークホール]<br>
              定員数：80名様<br>
              長崎県大村市幸町25-30<br>
              0957-54-3131
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：大村ここまで -->

          <!-- PC：久留米 -->
          <!-- <tr>
            <td class="text-center">4/26<br>（日）</td>
            <td class="text-center"><a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a></td>
            <td style="width: 70px;">久留米</td>
            <td>
              MSCセミナー久留米<br>
              ホテル マリターレ創世 [ピアッツア]<br>
              定員数：100名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：久留米ここまで -->
          
          <!-- PC:広島 -->
          <!-- <tr>
            <td class="text-center">4/13（月）</td>
            <td class="text-center"><a href="https://www.hgh.co.jp/access/"><img src="@/assets/img/lp/hiroshima_hgh.jpg" alt="広島" style="width: 150px;"></a></td>
            <td style="width: 70px;">広島</td>
            <td>
              MSCセミナー広島<br>
              ホテルグランヴィア広島 [悠久Dの間]<br>
              定員数：100名様<br>
              広島県広島市南区松原町1-5<br>
              082-262-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:広島ここまで -->

          <!-- PC：小倉 -->
          <!-- <tr>
            <td class="text-center">3/16<br>（月）</td>
            <td class="text-center"><a href="https://www.station-hotel.com/access/"><img src="@/assets/img/lp/kokura.jpg" alt="小倉" style="width: 150px;"></a></td>
            <td style="width: 70px;">小倉</td>
            <td>
              JR九州ステーションホテル小倉 [5階 飛翔（D）]<br>
              定員数：50~70名様<br>
              〒802-0001 北九州市小倉北区浅野1丁目1番1号<br>
              093-541-7111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：小倉ここまで -->
          
          <!-- PC：八王子 -->
          <!-- <tr>
            <td class="text-center">2/18<br>（水）</td>
            <td class="text-center"><a href="https://www.keioplaza.co.jp/hachioji/access/"><img src="@/assets/img/lp/hachiouji.jpg" alt="八王子" style="width: 150px;"></a></td>
            <td style="width: 70px;">八王子</td>
            <td>
              京王プラザホテル八王子 [5F 翔王A]<br>
              定員数：100名様<br>
              〒192-0083 東京都八王子市旭町14-1<br>
              042-656-3111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：八王子ここまで -->

          <!-- PC：大牟田 -->
          <!-- <tr>
            <td class="text-center">2/11<br>（水）</td>
            <td class="text-center"><a href="https://www.omuta-garden.jp/access/"><img src="@/assets/img/lp/oomuta.jpg" alt="大牟田" style="width: 150px;"></a></td>
            <td style="width: 70px;">大牟田</td>
            <td>
              ホテルニューガイアオームタガーデン [飛鳥]<br>
              定員数：50~70名様<br>
              〒836-0807 福岡県大牟田市旭町三丁目3番地3<br>
              0944-51-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：大牟田ここまで -->
        
          <!-- PC:名古屋 -->
          <!-- <tr>
            <td class="text-center">1/26（月）</td>
            <td class="text-center"><a href="https://www.tokyuhotels.co.jp/nagoya-h/access/index.html"><img src="@/assets/img/lp/nagoya_tokyuhotels.jpg" alt="名古屋" style="width: 150px;"></a></td>
            <td style="width: 70px;">名古屋</td>
            <td>
              名古屋東急ホテル [ロマネスク]<br>
              定員数：150名様<br>
              愛知県名古屋市中区栄4-6-8<br>
              052-251-2411
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:名古屋ここまで -->

          <!-- PC：宮崎 -->
          <!-- <tr>
            <td class="text-center">1/10<br>（土）</td>
            <td class="text-center"><a href="https://www.miyakan-h.com/outline/access.html"><img src="@/assets/img/lp/miyazaki.jpg" alt="宮崎" style="width: 150px;"></a></td>
            <td style="width: 70px;">宮崎</td>
            <td>
              宮崎観光ホテル [翠燿]<br>
              定員数：100名様<br>
              宮崎県宮崎市松山1-1-1<br>
              0985-27-1212
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：宮崎ここまで -->

          <!-- PC:福島 -->
          <!-- <tr>
            <td class="text-center">12/8（月）</td>
            <td class="text-center"><a href="https://www.hotel-hamatsu.co.jp/access/"><img src="@/assets/img/lp/fukushima_hamatsu.jpg" alt="福島" style="width: 150px;"></a></td>
            <td style="width: 70px;">福島</td>
            <td>
              ホテル ハマツ [平安の間・右近]<br>
              定員数：80名様<br>
              福島県郡山市虎丸町3-18<br>
              024-935-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:福島ここまで -->
          
          <!-- PC：奈良 -->
          <!-- <tr>
            <td class="text-center">12/1<br>（月）</td>
            <td class="text-center"><a href="https://grand-mercure-nara-kashihara.jp/access/"><img src="@/assets/img/lp/nara.jpg" alt="奈良" style="width: 150px;"></a></td>
            <td style="width: 70px;">奈良</td>
            <td>
              グランドメルキュール奈良橿原<br>[メインホール]<br>
              定員数：100名様<br>
              奈良県橿原市久米町652番地の2<br>
              0744-28-6636
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：奈良ここまで -->
          
          <!-- PC:仙台 -->
          <!-- <tr>
            <td class="text-center">11/10（月）</td>
            <td class="text-center"><a href="https://sendai.metropolitan.jp/access/"><img src="@/assets/img/lp/sendai.jpg" alt="仙台" style="width: 150px;"></a></td>
            <td style="width: 70px;">仙台</td>
            <td>
              ホテルメトロポリタン仙台 [星雲]<br>
              定員数：50名様<br>
              宮城県仙台市青葉区中央1丁目1-1<br>
              022-268-2525
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:仙台ここまで -->
          
          <!-- PC：福岡 -->
          <!-- <tr>
            <td class="text-center">11/4<br>（火）</td>
            <td class="text-center"><a href="https://fukuoka-orientalhotel.com/access/"><img src="@/assets/img/lp/hakata.jpg" alt="福岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">福岡</td>
            <td>
              オリエンタルホテル福岡 博多ステーション<br>[オリエンタルボールルーム 山笠]<br>
              定員数：100名様<br>
              福岡県福岡市博多区博多駅中央街4-23<br>
              092-461-0170
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：福岡ここまで -->

          <!-- PC：大宮 -->
          <!-- <tr>
            <td class="text-center">10/24<br>（金）</td>
            <td class="text-center"><a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a></td>
            <td style="width: 70px;">大宮</td>
            <td>
              パレスホテル大宮 [チェリールーム西]<br>
              定員数：100名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：大宮ここまで -->

          <!-- PC：大分 -->
          <!-- <tr>
            <td class="text-center">10/12<br>（日）</td>
            <td class="text-center"><a href="http://www.grand-plaza.jp/access"><img src="@/assets/img/lp/grand-plaza_oita.jpg" alt="大分" style="width: 150px;"></a></td>
            <td style="width: 70px;">大分</td>
            <td>
              グランプラザ中津ホテル [THE GRAND ROOM B]<br>
              定員数：50名様<br>
              大分県中津市東本町1-2<br>
              0979-24-7111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：大分ここまで -->

          <!-- PC：富山 -->
          <!-- <tr>
            <td class="text-center">10/2（木）</td>
            <td class="text-center"><a href="https://www.anacrowneplaza-toyama.jp/access/"><img src="@/assets/img/lp/toyama.jpg" alt="富山" style="width: 150px;"></a></td>
            <td style="width: 70px;">富山</td>
            <td>
              ANAクラウンプラザ [ASUKA]<br>
              定員数：60名様<br>
              富山県富山市大手町2番3号<br>
              0570-04-1080
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：富山ここまで -->

          <!-- PC:佐野 -->
          <!-- <tr>
            <td class="text-center">7/27（日）</td>
            <td class="text-center"><a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐野</td>
            <td>
              サンルート佐野 [平安]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:佐野ここまで -->
          
          <!-- PC:佐世保 -->
          <!-- <tr>
            <td class="text-center">7/5<br>（土）</td>
            <td class="text-center"><a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="長崎" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐世保</td>
            <td>
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：60名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:佐世保ここまで -->

          <!-- PC：松山 -->
          <!-- <tr>
            <td class="text-center">5/20<br>（火）</td>
            <td class="text-center"><a href="https://anacpmatsuyama.com/access/"><img src="@/assets/img/lp/matsuyama.jpg" alt="松山" style="width: 150px;"></a></td>
            <td style="width: 70px;">松山</td>
            <td>
              ANAクラウンプラザホテル松山 [エメラルド]<br>
              定員数：80名様<br>
              愛媛県松山市一番町3-2-1<br>
              089-933-5511
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：松山ここまで -->
          
          <!-- PC:広島 -->
          <!-- <tr>
            <td class="text-center">4/21（月）</td>
            <td class="text-center"><a href="https://www.kaigishitu.com/detail/45400/"><img src="@/assets/img/lp/hiroshima_tkp.jpg" alt="広島" style="width: 150px;"></a></td>
            <td style="width: 70px;">広島</td>
            <td>
              広島ウェルカムビジネスセミナー（オープン）<br>
              TKPガーデンシティPREMIUM広島駅前 [カンファレンスルーム7B]<br>
              定員数：50名様<br>
              広島県広島市南区大須賀町13-9 7階 ベルヴュオフィス広島 <br>
              082-569-9018<br>
              13:00～15:00（開場12:30）
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:広島ここまで -->

          <!-- PC:大宮 -->
          <!-- <tr>
            <td class="text-center">3/19（水）</td>
            <td class="text-center"><a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a></td>
            <td style="width: 70px;">大宮</td>
            <td>
              パレスホテル大宮 [チェリールーム]<br>
              開催時間：13:00～14:45<br>
              定員数：100名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:大宮ここまで -->
          
          <!-- PC：長崎 -->
          <!-- <tr>
            <td class="text-center">2/8<br>（土）</td>
            <td class="text-center"><a href="https://www.anacrowneplaza-nagasaki.jp/access.html"><img src="@/assets/img/lp/ana_nagasaki.jpg" alt="長崎" style="width: 150px;"></a></td>
            <td style="width: 70px;">長崎</td>
            <td>
              ANAクラウンプラザホテル長崎グラバーヒル [グラバーホール]<br>
              定員数：80名様<br>
              長崎県長崎市南山手町1-18<br>
              095-818-6601
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：長崎ここまで -->
          
          <!-- PC:名古屋 -->
          <!-- <tr>
            <td class="text-center">11/5（火）</td>
            <td class="text-center"><a href="https://www.meitetsu-gh.co.jp/access/"><img src="@/assets/img/lp/nagoya.jpg" alt="名古屋" style="width: 150px;"></a></td>
            <td style="width: 70px;">名古屋</td>
            <td>
              名鉄グランドホテル [柏]<br>
              定員数：100名様<br>
              愛知県名古屋市中村区名駅一丁目2番4号<br>
              名鉄バスターミナルビル 11F～18F<br>
              052-582-2211
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:名古屋ここまで -->

          <!-- PC：都城 -->
          <!-- <tr>
            <td class="text-center">10/27（日）</td>
            <td class="text-center"><a href="https://www.0986green.com/access-tourism/"><img src="@/assets/img/lp/miyakonojo.jpg" alt="都城" style="width: 150px;"></a></td>
            <td style="width: 70px;">都城</td>
            <td>
              都城グリーンホテル [第五会議室 ローズの間]<br>
              定員数：50名様<br>
              宮崎県都城市栄町27-2-1<br>
              0986-25-6111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：都城ここまで -->
          
          <!-- PC：延岡 -->
          <!-- <tr>
            <td class="text-center">9/7<br>（土）</td>
            <td class="text-center"><a href="https://www.encity-h.com/access/"><img src="@/assets/img/lp/nobeoka.jpg" alt="延岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">延岡</td>
            <td>
              エンシティホテル延岡 [山水]<br>
              定員数：50名様<br>
              宮崎県延岡市紺屋町1丁目4-28<br>
              0982-32-6060
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：延岡ここまで -->
          
          <!-- PC：久留米 -->
          <!-- <tr>
            <td class="text-center">5/21（火）</td>
            <td class="text-center"><a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a></td>
            <td style="width: 70px;">久留米</td>
            <td>
              ホテルマリターレ創世 久留米 [フローラ]<br>
              定員数：50名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：久留米ここまで -->

          <!-- PC：札幌 -->
          <!-- <tr>
            <td class="text-center">11/20（月）</td>
            <td class="text-center"><a href="https://newotanisapporo.com/access/"><img src="@/assets/img/lp/sapporo.jpg" alt="札幌" style="width: 150px;"></a></td>
            <td style="width: 70px;">札幌</td>
            <td>
              ニューオータニイン札幌 [北斗の間]<br>
              定員数：50名様<br>
              北海道札幌市中央区2条西1丁目1-1<br>
              011-222-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：札幌ここまで -->

          <!-- PC：佐世保 -->
          <!-- <tr>
            <td class="text-center">7/1（土）</td>
            <td class="text-center"><a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="佐世保" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐世保</td>
            <td>
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：100名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:佐世保ここまで -->

          <!-- PC:佐野 -->
          <!-- <tr>
            <td class="text-center">7/2（日）</td>
            <td class="text-center"><a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐野</td>
            <td>
              ホテルサンルート佐野 [平安西]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:佐野ここまで -->
          
          <!-- PC:福岡 -->
          <!-- <tr>
            <td class="text-center">7/21（金）</td>
            <td class="text-center"><a href="https://www.hotelnikko-fukuoka.com/access/"><img src="@/assets/img/lp/fukuoka_nikkou.jpg" alt="福岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">福岡</td>
            <td>
              ホテル日航福岡 [ラメール]<br>
              定員数：100名様<br>
              福岡市博多区博多駅前2丁目18番25号<br>
              092-482-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/cancel.jpg" alt="中止" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:福岡ここまで -->

          <!-- PC:浜松 -->
          <!-- <tr>
            <td class="text-center">6/7（水）</td>
            <td class="text-center"><a href="https://www.act-okura.co.jp/access/"><img src="@/assets/img/lp/hamamatsu_okura.jpg" alt="浜松" style="width: 150px;"></a></td>
            <td style="width: 70px;">浜松</td>
            <td>
              オークラアクトシティホテル浜松 [チェルシー]<br>
              定員数：50名様<br>
              静岡県浜松市中区板屋町111-2<br>
              053-459-0111
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:浜松ここまで -->          

        </tbody>
      </table>
    </div>
    
    <div class="only_sp">
            
      <!-- SP:大宮 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">6/17（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a><br>
              <span>大宮</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              パレスホテル大宮 [４階 ローズルーム]<br>
              定員数：80名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:大宮ここまで -->
      
      <!-- SP：大阪 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">6/25（木）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.granvia-osaka.jp/access/"><img src="@/assets/img/lp/oosaka_2.jpg" alt="大阪" style="width: 150px;"></a><br>
              <span>大阪</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルグランヴィア大阪 [名庭]<br>
              定員数：100名様<br>
              大阪市北区梅田3丁目1番1号(フロント19階)<br>
              0570-06-1235
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:大阪ここまで -->
      
      <!-- SP:東京 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/24（金）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://tokyo.hiltonjapan.co.jp/access/"><img src="@/assets/img/lp/tokyo_hilton.jpg" alt="東京" style="width: 150px;"></a><br>
              <span>東京</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ヒルトン東京 [3階 藤]<br>
              定員数：120名様<br>
              東京都新宿区西新宿6-6-2<br>
              03-3344-5111
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:東京ここまで -->
      
      <!-- SP:福岡 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">6/3（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://fukuoka-orientalhotel.com/access/"><img src="@/assets/img/lp/hakata.jpg" alt="福岡" style="width: 150px;"></a><br>
              <span>福岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              オリエンタルホテル福岡 博多ステーション [オリエンタルボールルーム 山笠]<br>
              定員数：100名様<br>
              福岡県福岡市博多区博多駅中央街4-23<br>
              092-461-0170
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:福岡ここまで -->
      
      <!-- SP:静岡 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/24（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://grandhillsshizuoka.jp/access/"><img src="@/assets/img/lp/shizuoka.jpg" alt="静岡" style="width: 150px;"></a><br>
              <span>静岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              グランヒルズ静岡 [5F センチュリールーム]<br>
              定員数：100名様<br>
              静岡県静岡市駿河区南町18-1<br>
              050-3185-7809
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:静岡ここまで -->
      
      <!-- SP:大村 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/18（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://parkbells.net/access/"><img src="@/assets/img/lp/nagasaki_oomura.jpg" alt="大村" style="width: 150px;"></a><br>
              <span>大村</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              MSCセミナー大村<br>
              パークベルズ大村 [デュークホール]<br>
              定員数：80名様<br>
              長崎県大村市幸町25-30<br>
              0957-54-3131
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大村ここまで -->

      <!-- SP：久留米 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">4/26（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a><br>
              <span>久留米</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              MSCセミナー久留米<br>
              ホテル マリターレ創世 [ピアッツア]<br>
              定員数：100名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:久留米ここまで -->
      
      <!-- SP:広島 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">4/13（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hgh.co.jp/access/"><img src="@/assets/img/lp/hiroshima_hgh.jpg" alt="広島" style="width: 150px;"></a><br>
              <span>広島</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              MSCセミナー広島<br>
              ホテルグランヴィア広島 [悠久Dの間]<br>
              定員数：100名様<br>
              広島県広島市南区松原町1-5<br>
              082-262-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:広島ここまで -->
      
      <!-- SP：小倉 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">3/16（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.station-hotel.com/access/"><img src="@/assets/img/lp/kokura.jpg" alt="小倉" style="width: 150px;"></a><br>
              <span>小倉</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              JR九州ステーションホテル小倉 [5階 飛翔（D）]<br>
              定員数：50~70名様<br>
              〒802-0001 北九州市小倉北区浅野1丁目1番1号<br>
              093-541-7111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:小倉ここまで -->
      
      <!-- SP：八王子 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">2/18（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.keioplaza.co.jp/hachioji/access/"><img src="@/assets/img/lp/hachiouji.jpg" alt="八王子" style="width: 150px;"></a><br>
              <span>八王子</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              京王プラザホテル八王子 [5F 翔王A]<br>
              定員数：100名様<br>
              〒192-0083 東京都八王子市旭町14-1<br>
              042-656-3111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:八王子ここまで -->
      
      <!-- SP：大牟田 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">2/11（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.omuta-garden.jp/access/"><img src="@/assets/img/lp/oomuta.jpg" alt="大牟田" style="width: 150px;"></a><br>
              <span>大牟田</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルニューガイアオームタガーデン [飛鳥]<br>
              定員数：50~70名様<br>
              〒836-0807 福岡県大牟田市旭町三丁目3番地3<br>
              0944-51-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大牟田ここまで -->
      
      <!-- SP：名古屋 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">1/26（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.tokyuhotels.co.jp/nagoya-h/access/index.html"><img src="@/assets/img/lp/nagoya_tokyuhotels.jpg" alt="名古屋" style="width: 150px;"></a><br>
              <span>名古屋</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              名古屋東急ホテル [ロマネスク]<br>
              定員数：150名様<br>
              愛知県名古屋市中区栄4-6-8<br>
              052-251-2411
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:名古屋ここまで -->
      
      <!-- SP：宮崎 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">1/10（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.miyakan-h.com/outline/access.html"><img src="@/assets/img/lp/miyazaki.jpg" alt="宮崎" style="width: 150px;"></a><br>
              <span>宮崎</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              宮崎観光ホテル [翠燿]<br>
              定員数：100名様<br>
              宮崎県宮崎市松山1-1-1<br>
              0985-27-1212
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:宮崎ここまで -->
       
      <!-- SP:福島 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/8（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotel-hamatsu.co.jp/access/"><img src="@/assets/img/lp/fukushima_hamatsu.jpg" alt="福島" style="width: 150px;"></a><br>
              <span>福島</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテル ハマツ [平安の間・右近]<br>
              定員数：80名様<br>
              福島県郡山市虎丸町3-18<br>
              024-935-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:福島ここまで -->
      
      <!-- SP:奈良 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/1（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://grand-mercure-nara-kashihara.jp/access/"><img src="@/assets/img/lp/nara.jpg" alt="奈良" style="width: 150px;"></a><br>
              <span>奈良</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              グランドメルキュール奈良橿原 [メインホール]<br>
              定員数：100名様<br>
              奈良県橿原市久米町652番地の2<br>
              0744-28-6636
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:奈良ここまで -->
      
      <!-- SP:仙台 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/10（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://sendai.metropolitan.jp/access/"><img src="@/assets/img/lp/sendai.jpg" alt="仙台" style="width: 150px;"></a><br>
              <span>仙台</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルメトロポリタン仙台 [星雲]<br>
              定員数：50名様<br>
              宮城県仙台市青葉区中央1丁目1-1<br>
              022-268-2525
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:仙台ここまで -->

      <!-- SP：大分 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">10/12（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="http://www.grand-plaza.jp/access"><img src="@/assets/img/lp/grand-plaza_oita.jpg" alt="大分" style="width: 150px;"></a><br>
              <span>大分</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              グランプラザ中津ホテル [THE GRAND ROOM B]<br>
              定員数：50名様<br>
              大分県中津市東本町1-2<br>
              0979-24-7111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大分ここまで -->
      
      <!-- SP:富山 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">10/2（木）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.anacrowneplaza-toyama.jp/access/"><img src="@/assets/img/lp/toyama.jpg" alt="富山" style="width: 150px;"></a><br>
              <span>富山</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ANAクラウンプラザ [ASUKA]<br>
              定員数：60名様<br>
              富山県富山市大手町2番3号<br>
              0570-04-1080
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:富山ここまで -->
      
      <!-- SP:佐野 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/27（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a><br>
              <span>佐野</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              サンルート佐野 [平安]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:佐野ここまで -->
      
      <!-- SP:佐世保 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/5（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="佐世保" style="width: 150px;"></a><br>
              <span>佐世保</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：60名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:佐世保ここまで -->

      <!-- SP：松山 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/20（火）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.anacpmatsuyama.com/access/"><img src="@/assets/img/lp/matsuyama.jpg" alt="松山" style="width: 150px;"></a><br>
              <span>松山</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ANAクラウンプラザホテル松山 [エメラルド]<br>
              定員数：80名様<br>
              愛媛県松山市一番町3-2-1<br>
              089-933-5511
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:松山ここまで -->
      
      <!-- SP:広島 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">4/21（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.kaigishitu.com/detail/45400/"><img src="@/assets/img/lp/hiroshima_tkp.jpg" alt="広島" style="width: 150px;"></a><br>
              <span>広島</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              広島ウェルカムビジネスセミナー（オープン）<br>
              TKPガーデンシティPREMIUM広島駅前 [カンファレンスルーム7B]<br>
              定員数：50名様<br>
              広島県広島市南区大須賀町13-9 7階 ベルヴュオフィス広島<br>
              082-569-9018<br>
              13:00～15:00（開場12:30）
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:広島ここまで -->
      
      <!-- SP：ANA長崎 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">2/8（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.anacrowneplaza-nagasaki.jp/access.html"><img src="@/assets/img/lp/ana_nagasaki.jpg" alt="長崎" style="width: 150px;"></a><br>
              <span>長崎</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ANAクラウンプラザホテル長崎グラバーヒル [グラバーホール]<br>
              定員数：80名様<br>
              長崎県長崎市南山手町1-18<br>
              095-818-6601
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:ANA長崎ここまで -->
      
      <!-- SP:大宮 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/9（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a><br>
              <span>大宮</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              パレスホテル大宮 [チェリールーム]<br>
              定員数：80名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大宮ここまで -->
      
      <!-- SP：名古屋 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/5（火）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.meitetsu-gh.co.jp/access/"><img src="@/assets/img/lp/nagoya.jpg" alt="名古屋" style="width: 150px;"></a><br>
              <span>名古屋</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              名鉄グランドホテル [柏]<br>
              定員数：100名様<br>
              愛知県名古屋市中村区名駅一丁目2番4号<br>
              名鉄バスターミナルビル 11F～18F<br>
              052-582-2211
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:名古屋ここまで -->
      
      <!-- SP:都城 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">10/27（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.0986green.com/access-tourism/"><img src="@/assets/img/lp/miyakonojo.jpg" alt="都城" style="width: 150px;"></a><br>
              <span>都城</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              都城グリーンホテル [第五会議室 ローズの間]<br>
              定員数：50名様<br>
              宮崎県都城市栄町27-2-1<br>
              0986-25-6111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:都城ここまで -->
      
      <!-- SP:延岡 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">9/7（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.encity-h.com/access/"><img src="@/assets/img/lp/nobeoka.jpg" alt="延岡" style="width: 150px;"></a><br>
              <span>延岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              エンシティホテル延岡 [山水]<br>
              定員数：50名様<br>
              宮崎県延岡市紺屋町1丁目4-28<br>
              0982-32-6060
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大村ここまで -->

      <!-- SP：久留米 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/21（火）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a><br>
              <span>久留米</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルマリターレ創世 久留米 [フローラ]<br>
              定員数：50名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:久留米ここまで -->
      
      <!-- SP：札幌 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/20（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://newotanisapporo.com/access/"><img src="@/assets/img/lp/sapporo.jpg" alt="札幌" style="width: 150px;"></a><br>
              <span>札幌</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ニューオータニイン札幌 [北斗の間]<br>
              定員数：50名様<br>
              北海道札幌市中央区2条西1丁目1-1<br>
              011-222-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:札幌ここまで -->
            
      <!-- SP:佐野 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/2（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a><br>
              <span>佐野</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルサンルート佐野 [平安西]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:佐野ここまで -->
      
      <!-- SP:福岡 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/21（金）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotelnikko-fukuoka.com/access/"><img src="@/assets/img/lp/fukuoka_nikkou.jpg" alt="福岡" style="width: 150px;"></a><br>
              <span>福岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/cancel.jpg" alt="中止" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテル日航福岡 [ラメール]<br>
              定員数：100名様<br>
              福岡市博多区博多駅前2丁目18番25号<br>
              092-482-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:福岡ここまで -->

      <!-- SP:浜松 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">6/7（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.act-okura.co.jp/access/"><img src="@/assets/img/lp/hamamatsu_okura.jpg" alt="浜松" style="width: 150px;"></a><br>
              <span>浜松</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              オークラアクトシティホテル浜松 [チェルシー]<br>
              定員数：50名様<br>
              静岡県浜松市中区板屋町111-2<br>
              053-459-0111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:浜松ここまで -->

    </div>
  </section>

  <section class="msc_seminar mt-5">
    <div>
      <p class="text-center mt-5">
        限定数に達した時点で、受付は終了させていただきますので予めご了承ください。
      </p>
      <p class="text-center mt-3">
        ★各会場の案内板等でお部屋をご確認のうえ、お越しください。
      </p>
    </div>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">【ご参加の皆さまへ】</h3>
    <ul class="seminar_text_list list-dot-01">
      <li>日程に変更があった場合、メール、ホームページ等でお知らせいたします。</li>
      <li>マイクロバス等でご来場の場合、事前にご自身で駐車場の状況を会場側にご確認ください。</li>
      <li>入室の際には、アルコール消毒のご協力をお願いいたします。また、発熱等、体調が優れない場合にはご来場をお控えください。</li>
    </ul>

    <p class="text-center mt-5">ご質問やご不明な点などございましたら、会員サポート部までお問合せください。</p>
    <div class="d-flex justify-content-center align-items-center mt-5">
        <P>株式会社マナビス化粧品<br>会員サポート部</p>
        <img src="@/assets/img/lp/tel.png" alt="電話" class="mx-5">
        <p style="font-size: 3rem;">0120-268-510</p>
    </div>

  </section>
    



  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<!-- 化粧品公式サイトのスタイルを反映 -->
<style src="../../assets/css/custom.css" scoped>
</style>
<style src="../../assets/css/module.css" scoped>
</style>
<style src="../../assets/css/module_sp.css" scoped>
</style>
<style src="../../assets/css/top.css" scoped>
</style>

<style scoped>
.box-top-slide {
  height: initial;
}
.seminar_table thead {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  line-height: 50px;
}
.seminar_table th {
  font-weight: 300;
}
.seminar_table tbody tr {
  border-bottom: 1px solid #eee;
  height: 150px;
}
.seminar_table td {
  vertical-align: middle;
}
.seminar_table td:first-child {
  font-size: 24px;
}
.seminar_table td.w-100px {
  width: 100px;
}
.list_style_non li {
  list-style: none;
  margin-left: 0;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}

@media screen and (min-width: 1px) and (max-width: 699px) {
  .msc_seminar .d-flex {
    flex-direction: column;
  }
  .only_sp .seminar_table tr {
    height: initial;
  }
  .only_sp .seminar_table th {
    vertical-align: middle;
  }
  .only_sp .seminar_table td {
    padding: 10px 0 10px 20px;
  }
  .only_sp .seminar_table tr:first-child {
     border-top: 1px solid #eee;
  }
  .only_sp .seminar_table tr:first-child td {
    font-size: 24px;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>